import {
  getCurrentQuizType,
  getIsQuestionMarked,
  getQuizQuestionAnswers,
  getCurrentQuestionInfo,
  getIsQuestionUnanswered
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useQuestionStatus = (sectionUID, questionUID) => {
  const { isSubjective } = useSelectorWithShallowEqual(getCurrentQuizType);
  const answers = useSelectorWithShallowEqual(
    getQuizQuestionAnswers(sectionUID, questionUID)
  );
  const isMarked = useSelectorWithShallowEqual(
    getIsQuestionMarked(sectionUID, questionUID)
  );
  const isUnanswered = useSelectorWithShallowEqual(
    getIsQuestionUnanswered(sectionUID, questionUID)
  );
  const { sectionUID: selectedSectionUID, questionUID: selectedQuestionUID } =
    useSelectorWithShallowEqual(getCurrentQuestionInfo);

  const isAttempted = isSubjective ? answers[0] === '1' : answers.length > 0;

  return {
    isSelected:
      sectionUID === selectedSectionUID && questionUID === selectedQuestionUID,
    isAttempted,
    isMarked,
    isMarkedAndAttempted: isMarked && isAttempted,
    isUnanswered
  };
};

export default useQuestionStatus;
